<template lang="html">
  <div class="slide">
    <svg ref="scene" class="canvas" :viewBox="`0 0 ${canvasWidth} ${canvasHeight}`" xmlns="http://www.w3.org/2000/svg">
      <rect id="Frame" x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
      <rect x="0" y="0" :width="canvasWidth" :height="canvasHeight" fill="rgb(10,10,10)" />
      <image ref="scan" :style="{transformOrigin: `${2306/2}px ${3005/2}px`}" :transform-origin="`${2306/2} ${3005/2}`" width="2307" height="3005" :xlink:href="`${publicPath}scenes/shonto/scan-w1200.jpg`" />
    </svg>
    <SceneDialogue
      ref="dialogue"
      :width="0.39"
      :bg="`transparent`"
      :fontSize="24"
      :styles="{color: `white`, textAlign: `left`, fontFamily: `Minion Pro`, lineHeight: `1.5em`}"
      :tx="1" :ty="0.5">
      At Haskell, Max wrote letters home. A man at Shonto Trading Post translated Max’s letters for his mom and pops. A few years in, though, his parents started to get worried. Grandpa Jim sent a letter asking Max to come home. When he left, Max never forgot about Haskell—he even named my brother Lawrence after Lawrence, Kansas.
    </SceneDialogue>
    <SceneDialogue
      ref="date"
      :width="0.251"
      :bg="`rgba(30,30,30,1)`"
      :fontSize="24"
      :styles="{padding: '0.5em', color: `white`, textAlign: `left`, fontFamily: 'courier', lineHeight: `1.5em`}"
      :tx="0.65" :ty="0.15">
      April 1st, 1924
    </SceneDialogue>
    <SceneAudio ref="scene-audio" :src="`${publicPath}scenes/shonto/audio-charlie-navajo.mp3`" />
  </div>
</template>

<script>
import Template from "./Template"
import SceneDialogue from "../SceneDialogue.vue"
import {TimelineLite, TweenLite} from "gsap"

export default {
  extends: Template,
  data: () => ({
    publicPath: process.env.BASE_URL,
    canvasWidth: 4175,
    canvasHeight: 3006,
    contentPadding: 20,
    dy: 0,
    tl: null,
  }),
  props: ["slide"],
  mounted() {
    const { scan } = this.$refs
    const d = this.$refs["dialogue"].$el
    const date = this.$refs["date"].$el
    // this.tl = new TimelineLite({paused: true})
    TweenLite.set(scan, {opacity: 0, scale: 0.8})
    TweenLite.set(d, {opacity: 0})
    TweenLite.set(date, {opacity: 0})
    this.tl.add(TweenLite.to(scan, 1, {opacity: 1, scale: 1,rotate: "-10deg"}), "+=0.5")
    this.tl.add(TweenLite.to(date, 1, {opacity: 1}))
    this.tl.add(TweenLite.to(d, 1, {opacity: 1}), "-=1")
  },
  methods: {
    loaded() {},
    enter() {
      this.tl.play()
    },
    exit() {},
  },
  components: {
    SceneDialogue,
  },
}
</script>
